import ChargeCenterMonitor from '@/app/routes/ChargeCenter/ChargeCenterMonitor';
import { chargeCenterMonitorLayoutRoute } from '@/modules/charge-center/layout/route';
import { createRoute } from '@tanstack/react-router';

export const chargeCenterIndexRoute = createRoute({
  getParentRoute: () => chargeCenterMonitorLayoutRoute,
  path: '/',
  wrapInSuspense: true,
  component: ChargeCenterMonitor,
});
